import { Country } from 'company/domain/country'
import { ICountryRepository } from '../domain/ICountryRepository'
import { trackingAxios } from 'config/api/tracking'

interface ApiCountryResponse {
    id: number
    name: string
    code: string
}

interface ApiResponse {
    totalItems: number
    items: ApiCountryResponse[]
    page: number
    size: number
}

export class AxiosCountryRepository implements ICountryRepository {
    constructor() {}

    async get(): Promise<Country[]> {
        try {
            const response = await trackingAxios.get<ApiResponse>('/countries')

            if (response.data === null || response.data === undefined) {
                return []
            }

            const items = Array.isArray(response.data)
                ? response.data
                : response.data.items

            if (
                items === null ||
                items === undefined ||
                !Array.isArray(items)
            ) {
                return []
            }

            return items.map((item) => ({
                id: item.id,
                name: item.name,
                code: item.code,
            }))
        } catch (error) {
            console.error(
                '[AxiosCountryRepository] Error fetching countries:',
                error
            )
            throw error
        }
    }
}
